import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, unref as _unref, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 1921 273.4",
  style: {"enable-background":"new 0 0 1921 273.4"},
  "xml:space": "preserve"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0,0l1921,0v83.4c-144-47.7-360.3-73.9-609.1-73.9c-110.5,0-225.4,5.2-341.7,15.3C865.3,34,761.8,47.1,662.7,63.7C566.6,79.7,475,99,390.5,120.9C222.9,164.5,87.9,217.2,0,273.4L0,0z",
  fill: "#fff"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "base-mobile-navigation__content" }
const _hoisted_7 = { class: "container-fluid" }
const _hoisted_8 = { class: "aside-items" }

import BaseFixedAsideElementMobileToggle from '@/components/aside/BaseFixedAsideElementMobileToggle.vue';
import {
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from 'vue';
import { useStore } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUserCircle,
  faSearch,
} from '@fortawesome/pro-light-svg-icons';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import AsideItems, { AsideItem } from '@/data/AsideItems';
import { useRoute } from 'vue-router';

const asideItemTransitionDuration = 475;


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileNavigation',
  setup(__props) {

library.add(faUserCircle, faSearch, faXmark);

const store = useStore();
const toggleSidebar = () => {
  store.dispatch('sidebar/toggle', 'sidebar');
};

const route = useRoute();
const asideItemOpen = ref<boolean>(false);
const selectedAsideItem = ref<AsideItem>();
const selectedAsideItemInx = ref<number>();
const closeAsideItem = () => {
  asideItemOpen.value = false;

  setTimeout(() => {
    selectedAsideItem.value = undefined;
    selectedAsideItemInx.value = undefined;
  }, asideItemTransitionDuration);
};
const selectAsideItem = (inx: number) => {
  if (selectedAsideItemInx.value === inx) {
    closeAsideItem();

    return;
  }

  selectedAsideItem.value = AsideItems[inx];
  if (selectedAsideItem.value === undefined) return;

  store.dispatch('sidebar/close');
  selectedAsideItemInx.value = inx;
  asideItemOpen.value = true;
};
const toggleAsideItem = (inx: number) => {
  const selectedItem = AsideItems[inx];

  if (selectedItem.link) {
    closeAsideItem();

    return;
  }

  if (selectedAsideItem.value !== undefined) {
    asideItemOpen.value = false;

    setTimeout(() => {
      selectAsideItem(inx);
    }, asideItemTransitionDuration);

    return;
  }

  selectAsideItem(inx);
};
watch(() => route.fullPath, closeAsideItem);

const root = ref<HTMLElement>();
const waveEl = ref<HTMLElement>();
const setBodyStyle = (padding: number | undefined = undefined) => {
  const bodyEl = document.querySelector('body');

  if (!bodyEl) return;
  if (padding !== undefined) {
    bodyEl.style.paddingBottom = `${padding}px`;

    return;
  }

  if (!root.value) return;
  if (!waveEl.value) return;

  bodyEl.style.paddingBottom = `${root.value.offsetHeight + waveEl.value.offsetHeight}px`;
};
const setBodyPaddingBottom = () => {
  setBodyStyle();
};

onMounted(() => {
  window.addEventListener('resize', setBodyPaddingBottom);
  window.addEventListener('load', setBodyPaddingBottom);
  window.addEventListener('app.sidebar.open', closeAsideItem);
  setBodyPaddingBottom();
  for (let i = 100; i < 1000; i += 100) {
    setTimeout(setBodyPaddingBottom, i);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setBodyPaddingBottom);
  window.removeEventListener('load', setBodyPaddingBottom);
  window.removeEventListener('app.sidebar.open', closeAsideItem);
  setBodyStyle(0);
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "base-mobile-navigation"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["aside-item-wrapper", {
          'open': asideItemOpen.value
        }]),
      style: _normalizeStyle({
          '--item-transition-duration': `${asideItemTransitionDuration / 1000}s`
        })
    }, [
      (selectedAsideItem.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "aside-item-content",
              innerHTML: selectedAsideItem.value.content
            }, null, 8, _hoisted_2),
            _createElementVNode("div", {
              class: "aside-item-close",
              onClick: closeAsideItem
            }, [
              _createVNode(_component_FontAwesomeIcon, { icon: "fa-regular fa-xmark" })
            ])
          ]))
        : _createCommentVNode("", true)
    ], 6),
    _createElementVNode("div", {
      ref_key: "waveEl",
      ref: waveEl,
      class: "base-mobile-navigation__wave"
    }, [
      (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
    ], 512),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AsideItems), (item, inx) => {
            return (_openBlock(), _createBlock(BaseFixedAsideElementMobileToggle, _mergeProps({
              key: `mobile-aside-item-${inx}`,
              style: {
                gridColumn: `${inx + 1} / ${inx + 2}`,
              },
              active: selectedAsideItemInx.value === inx
            }, item, {
              onClick: ($event: any) => (toggleAsideItem(inx))
            }), null, 16, ["style", "active", "onClick"]))
          }), 128))
        ]),
        _createElementVNode("button", {
          class: "sidebar-toggle",
          onClick: toggleSidebar
        }, [
          _createVNode(_component_FontAwesomeIcon, { icon: "fa-light fa-bars" })
        ])
      ])
    ])
  ], 512))
}
}

})